import { table } from "../utils/pg-ts/pg-ts";
import { NonEmptyString } from "io-ts-types";
import {
    organizationIdCodec,
    organizationsWithSubdomainView,
} from "./organization";
import { pick } from "../utils/fp";
import { pipe } from "fp-ts/function";
import * as t from "io-ts";
import { commonIdCodec } from "./common";

export const clubsTable = table("clubs", {
    id: commonIdCodec,
    organization_id: organizationIdCodec,
    title: NonEmptyString,
    ignored: t.boolean, // will not be selectable from autocompletes and will be skipped from club rankings
});

export const organizationClubsView = table("organization_clubs", {
    ...clubsTable.columns,
    ...pipe(organizationsWithSubdomainView.columns, pick("subdomain")),
    results_count: t.Int,
});
